export default __webpack_public_path__ + "static/media/Julie_Testa.fec04c53.jpg";